import { MediaTrack } from "../endpoints/mediaTrack";

export class ProducerInfo {
    constructor(public readonly name: string, public readonly kind: string, public readonly id: string, public mediaTrack: MediaTrack | null){}
}
